<template>
  <div :class="['micad_flags',getType(type)]">{{message}}</div>
</template>

<script>
export default {
  name: 'Flags',
  props: {
    type: String,
    message: String
  },
  methods: {
   getType(type) {
      if (type !== undefined) {
        return ' micad_flags_'+type
      }
    }
  }
};
</script>

